<script setup>
import LinkedInIcon from '@/Components/Icons/Socials/LinkedIn.vue';
const navigation = {
  products: [{name: 'Hire Smart', href: route('products.hire-smart')}],
  industries: [
    {name: 'Deep Tech Industry', href: route('industries.show', {industry: 'deep-tech'})},
    {name: 'Digital Solutions', href: route('industries.show', {industry: 'digital-solutions'})},
    {name: 'Renewable Energy', href: route('industries.show', {industry: 'renewable-energy'})},
    {name: 'Financial Services', href: route('industries.show', {industry: 'financial-services'})},
    {
      name: 'Health & Life Sciences',
      href: route('industries.show', {industry: 'health-and-life-sciences'}),
    },
    {
      name: 'Media & Entertainment',
      href: route('industries.show', {industry: 'media-and-entertainment'}),
    },
  ],
  jobCategories: [
    {name: 'Hire Engineers', href: route('categories.show', {category: 'engineers'})},
    {name: 'Hire Designers', href: route('categories.show', {category: 'designers'})},
    {name: 'Hire Managers', href: route('categories.show', {category: 'managers'})},
    {
      name: 'Hire Sales & Marketing',
      href: route('categories.show', {category: 'sales-and-marketing'}),
    },
    {
      name: 'Hire HR & Administrative',
      href: route('categories.show', {category: 'hr-and-administrative'}),
    },
    {name: 'Hire Executives', href: route('categories.show', {category: 'executives'})},
  ],
  company: [
    {name: 'About us', href: route('about')},
    {name: 'Why 360AI', href: route('why-360ai')},
    {name: 'Contact us', href: route('contact')},
{name: 'Blog', href: route('blog')},
    {name: 'API Docs', href: '/docs'},
    {name: 'Accessibility', href: route('accessibility')},
  ],
  policies: [
    {name: 'Terms of service', href: route('terms.show')},
    {name: 'Privacy policy', href: route('policy.show')},
    {name: 'My privacy choices', href: route('my-privacy-choices')},
  ],
  social: [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/360ai-official',
      icon: LinkedInIcon,
    },
  ],
};
</script>

<template>
  <footer
    class="relative z-10 border border-t bg-white print:hidden"
    aria-labelledby="footer-heading"
  >
    <h2
      id="footer-heading"
      class="sr-only"
      >Footer</h2
    >
    <div class="mx-auto max-w-7xl px-6 pb-8 pt-20 sm:pt-24 lg:px-8">
      <div class="xl:grid xl:grid-cols-2 xl:gap-8">
        <div class="grid grid-cols-2 gap-8 sm:grid-cols-4 xl:col-span-2">
          <div>
            <h3 class="text-sm font-semibold leading-6 text-gray-900">Company</h3>
            <ul
              role="list"
              class="mt-6 space-y-4"
            >
              <li
                v-for="item in navigation.company"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <!-- <div>
            <h3 class="text-sm font-semibold leading-6 text-gray-900">Products</h3>
            <ul
              role="list"
              class="mt-6 space-y-4"
            >
              <li
                v-for="item in navigation.products"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div> -->
          <div>
            <h3 class="text-sm font-semibold leading-6 text-gray-900">Industries</h3>
            <ul
              role="list"
              class="mt-6 space-y-4"
            >
              <li
                v-for="item in navigation.industries"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h3 class="text-sm font-semibold leading-6 text-gray-900">Categories</h3>
            <ul
              role="list"
              class="mt-6 space-y-4"
            >
              <li
                v-for="item in navigation.jobCategories"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h3 class="text-sm font-semibold leading-6 text-gray-900">Policies</h3>
            <ul
              role="list"
              class="mt-6 space-y-4"
            >
              <li
                v-for="item in navigation.policies"
                :key="item.name"
              >
                <a
                  :href="item.href"
                  class="text-sm leading-6 text-gray-600 hover:text-gray-900"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-16"
      >
        <div class="flex items-center space-x-6 md:order-2">
          <a
            v-for="item in navigation.social"
            :key="item.name"
            :href="item.href"
            target="_blank"
            class="text-gray-400 hover:text-gray-500"
          >
            <span class="sr-only">{{ item.name }}</span>
            <component
              :is="item.icon"
              class="h-6 w-6"
              aria-hidden="true"
            />
          </a>
        </div>
        <p class="mt-8 text-xs leading-5 text-gray-500 md:order-1 md:mt-0">
          Copyright &copy; {{ new Date().getFullYear() }}. All Rights Reserved.
        </p>
      </div>
    </div>
  </footer>
</template>
